import React from 'react'
import PropTypes from 'prop-types'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  TextField
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { ModalConfirmacao } from 'components'
import useStyles from './DashboardConfigModal.styles'

/**
 * Presentational component for the dashboard panel settings modal.
 * Contains selects, conditional autocomplete loading for sectors, and confirmation actions.
 */
export const DashboardConfigModal = ({
  open,
  section,
  onClose,
  onConfirm,
  selectedType,
  setSelectedType,
  selectedSector,
  setSelectedSector,
  sectors,
  loadingSectors
}) => {
  const classes = useStyles()

  // Verify if the active cell type needs a sector configuration
  const typeRequiresSector = (type) => {
    return ['vestigios_setor', 'exames_solicitados_setor', 'vestigios_setor_mes', 'exames_setor_mes'].includes(type)
  }

  return (
    <ModalConfirmacao
      aberto={open}
      titulo={`CONFIGURAR ${section.toUpperCase()}`}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmarLabel="Salvar Painel"
      cancelarLabel="Voltar"
    >
      <div className={classes.modalForm}>
        {/* Cell Type Selector */}
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="select-cell-type-label">TIPO DO PAINEL</InputLabel>
          <Select
            labelId="select-cell-type-label"
            value={selectedType}
            onChange={(e) => {
              setSelectedType(e.target.value)
              setSelectedSector(null) // Reset sector on type change
            }}
            label="TIPO DO PAINEL"
          >
            {section === 'kpis' && [
              <MenuItem key="kpi-1" value="cadaveres_dia">Cadáveres no dia em cada regional</MenuItem>,
              <MenuItem key="kpi-2" value="exames_dia">Exames no dia em cada regional</MenuItem>,
              <MenuItem key="kpi-3" value="vestigios_dia">Vestígios no dia em cada regional</MenuItem>,
              <MenuItem key="kpi-4" value="vestigios_setor">Vestígios no setor...</MenuItem>,
              <MenuItem key="kpi-5" value="vestigios_usuario">Meus vestígios em posse</MenuItem>,
              <MenuItem key="kpi-6" value="exames_atribuidos">Meus exames atribuídos</MenuItem>,
              <MenuItem key="kpi-7" value="exames_solicitados_setor">Exames solicitados ao setor...</MenuItem>,
            ]}
            {section === 'charts' && [
              <MenuItem key="chart-1" value="cadaveres_mes">Cadáveres por mês em cada regional</MenuItem>,

              <MenuItem key="chart-3" value="vestigios_setor_mes">Vestígios recebidos no setor por mês...</MenuItem>,
              <MenuItem key="chart-4" value="exames_setor_mes">Exames solicitados ao setor por mês...</MenuItem>,
              <MenuItem key="chart-5" value="exames_atribuidos_mes">Meus exames atribuídos por mês</MenuItem>,
              <MenuItem key="chart-6" value="exames_publicados_mes">Meus exames finalizados por mês</MenuItem>,
            ]}
            {section === 'tables' && [
              <MenuItem key="table-1" value="ultimos_cadaveres">Últimos cadáveres cadastrados</MenuItem>,
              <MenuItem key="table-2" value="ultimos_exames_atribuidos">Últimos exames atribuídos a mim</MenuItem>,
              <MenuItem key="table-3" value="ultimos_exames_solicitados">Últimos exames que solicitei</MenuItem>,
            ]}
          </Select>
        </FormControl>

        {/* Conditional Sector Autocomplete Field */}
        {typeRequiresSector(selectedType) && (
          <Autocomplete
            options={sectors}
            getOptionLabel={(option) => option.nome || ''}
            value={selectedSector}
            loading={loadingSectors}
            noOptionsText="Nenhum setor localizado"
            loadingText="Carregando setores..."
            onChange={(event, newValue) => setSelectedSector(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="SELECIONE O SETOR"
                variant="outlined"
                required
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingSectors ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        )}
      </div>
    </ModalConfirmacao>
  )
}

DashboardConfigModal.propTypes = {
  open: PropTypes.bool.isRequired,
  section: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  selectedType: PropTypes.string.isRequired,
  setSelectedType: PropTypes.func.isRequired,
  selectedSector: PropTypes.object,
  setSelectedSector: PropTypes.func.isRequired,
  sectors: PropTypes.array.isRequired,
  loadingSectors: PropTypes.bool.isRequired,
}
